// https://github.com/fend25/strg.js/blob/master/only/cookiestore.js

export const cookie = {
    s: document.cookie,
    type: 'cookie',
    set(name, value, expires, path) {
        const valueToUse =
            value !== undefined && typeof value === 'object'
                ? encodeURIComponent('j:' + JSON.stringify(value))
                : encodeURIComponent(value);

        document.cookie =
            name +
            '=' +
            valueToUse +
            (expires ? '; expires=' + new Date(expires).toUTCString() : '') +
            '; path=' +
            (path || '/') +
            (location.protocol === 'https:' ? '; secure' : '');
    },
    get(name) {
        const cookies = this.getAllRawOrProcessed(false);

        return cookies.hasOwnProperty(name)
            ? this.processValue(cookies[name])
            : undefined;
    },
    processValue(value) {
        if (value === 'undefined') return undefined;

        try {
            return JSON.parse(decodeURIComponent(value.replace('j%3A', '')));
        } catch (e) {
            return value;
        }
    },
    getAllRawOrProcessed(process) {
        const cookies = document.cookie.split('; ');
        const s = {};

        if (cookies.length === 1 && cookies[0] === '') return s;

        cookies.forEach(function(cookie) {
            const cookieParts = cookie.split('=');
            if (process) {
                s[cookie[0]] = this.processValue(cookieParts[1]);
            } else {
                s[cookieParts[0]] = cookieParts[1];
            }
        });

        return s;
    },
    getAll() {
        return this.getAllRawOrProcessed(true);
    },
    remove(name) {
        this.set(name, '', -1);
    },
    removeAll() {
        this.getAll().forEach(function(cookie) {
            this.remove(cookie);
        });

        return this.getAll();
    }
};
